import { getDownloadURL, ref } from "firebase/storage";
import { useEffect, useState } from "react";
import { storage } from "src/firebase";

export const useDownloadUrl = (path?: string) => {
  const [fileUrl, setFileUrl] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    if (!path) {
      setLoading(false);
      setError(true);
    }

    const fetchUrl = async () => {
      try {
        const url = await getDownloadURL(ref(storage, path));
        setFileUrl(url);
      } catch (error) {
        console.error("Failed to load download URL:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUrl();
  }, [path]);

  return { fileUrl, loading, error };
};
